<div class="modal-overlay" *ngIf="show">
  <div class="create-role-modal">
    <div class="modal-header">
      <h3>Create New Role</h3>
      <i class="bi bi-x close-icon" (click)="onClose()"></i>
    </div>

    <div class="modal-body">
      <label for="roleName" class="role-label">Role Name</label>
      <input id="roleName" type="text" class="role-input" placeholder="Enter role name" [(ngModel)]="newRoleName" />
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" (click)="onClose()">Cancel</button>
      <button class="save-btn" (click)="onSave()">Save</button>
    </div>
  </div>
</div>